<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <span class="slide">*NOTE:Question Image File size Should be less than {{ imagesize_new }} KB And It Should be
            in <span v-for="(img, index) in imagetype_new" :key="index"> {{ img.imagetype }} </span>Format!!!</span>
        <v-card class="box">
            <div>
                <v-btn icon @click="showEditor" style="float: right;"> <v-icon title="CK Text Editor"
                        color="black">mdi-file-edit-outline</v-icon></v-btn>
            </div>
            <v-row dense justify="center">
                <v-col cols="12" sm="6" md="6">
                    <!-- <p class="p-0 m-0"><b>Question Title New</b></p> -->
                    <!-- <ckeditor v-model="question" :config="editorConfig"></ckeditor> -->
                    <v-textarea label="Question Title New" auto-grow v-model="question" outlined rows="3"></v-textarea>
                </v-col>
                <v-col cols="12" sm="3" md="3" align="right">
                    <v-file-input v-model="qfile"
                        hint="Question Image File size Should be less than 200kb And It Should be in JPEG Format"
                        accept="image/*" id="file" prepend-icon="mdi-attachment" label="Choose File" show-size
                        name="doc" @change="validateFile()"></v-file-input>
                    <!-- @change="validateFile(qfile, 'question')" -->
                </v-col>
            </v-row>
            <v-row dense justify="center">
                <v-col cols="12" sm="4">
                    <b>Total Weightage - {{ total_weightage }}</b>
                </v-col>
            </v-row>
        </v-card>
        <!-- <v-card class="box">
      <v-row dense justify="center">
        <v-col cols="12" sm="3" md="3">
          <p class="p-0 m-0"><b>Weightage</b></p>
          <v-text-field
            class="p-0 m-0"
            v-model.trim="sub_answer_01_marks"
            type="number"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense justify="center">
        <v-col cols="12" sm="5" md="5">
          <p class="p-0 m-0"><b>Question - 1</b></p>
          <ckeditor v-model="sub_question_01" :config="editorConfig"></ckeditor>
          <v-file-input
            accept="image/jpeg, image/jpg"
            v-model="sub_question_01_file"
            hint="Option Image File size Should be less than 200kb And It Should be in JPEG Format"
            prepend-icon="mdi-attachment"
            label="Choose File"
            id="file1"
            show-size
            name="doc"
           
          ></v-file-input>
        </v-col>
        <v-col cols="12" sm="1" md="1">
          <center>
            <v-icon color="black" class="format-icon"
              >mdi-arrow-left-right-bold</v-icon
            >
          </center>
        </v-col>
        <v-col cols="12" sm="5" md="5">
          <p class="p-0 m-0"><b>Correct Answer</b></p>
          <ckeditor v-model="sub_answer_01" :config="editorConfig"></ckeditor>
          <v-file-input
            accept="image/jpeg, image/jpg"
            v-model="sub_answer_01_file"
            hint="Option Image File size Should be less than 200kb And It Should be in JPEG Format"
            prepend-icon="mdi-attachment"
            label="Choose File"
            id="file1"
            show-size
            name="doc"
          
          ></v-file-input>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="box">
      <v-row dense justify="center">
        <v-col cols="12" sm="3" md="3">
          <p class="p-0 m-0"><b>Weightage</b></p>
          <v-text-field
            class="p-0 m-0"
            v-model.trim="sub_answer_01_marks"
            type="number"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col cols="12" sm="5" md="5">
          <p class="p-0 m-0"><b>Question - 2</b></p>
          <ckeditor v-model="sub_question_02" :config="editorConfig"></ckeditor>
          <v-file-input
            accept="image/jpeg, image/jpg"
            v-model="sub_question_02_file"
            hint="Option Image File size Should be less than 200kb And It Should be in JPEG Format"
            prepend-icon="mdi-attachment"
            label="Choose File"
            id="file1"
            show-size
            name="doc"
           
          ></v-file-input>   
        </v-col>
        <v-col cols="12" sm="1" md="1" justify="center">
          <v-icon color="black" class="format-icon"
            >mdi-arrow-left-right-bold</v-icon
          >
        </v-col>
        <v-col cols="12" sm="5" md="5">
          <p class="p-0 m-0"><b>Correct Answer</b></p>
          <ckeditor v-model="sub_answer_02" :config="editorConfig"></ckeditor>
          <v-file-input
            accept="image/jpeg, image/jpg"
            v-model="sub_answer_02_file"
            hint="Option Image File size Should be less than 200kb And It Should be in JPEG Format"
            prepend-icon="mdi-attachment"
            label="Choose File"
            id="file1"
            show-size
            name="doc"
           
          ></v-file-input>
        </v-col>
      </v-row>
    </v-card> -->
        <v-dialog v-model="imageSizeFlag" persistent max-width="400px">
            <v-card>
                <v-card-title class="headline"> File Size </v-card-title>
                <v-container>
                    <span>
                        <v-col cols="12" xs="12" sm="12">
                            <p class="slide">File size should be less than {{ imagesize_new }}!</p>
                        </v-col>
                    </span>
                    <center>
                        <v-btn class="button" text @click="imageSizeFlag = false">OK</v-btn>
                    </center>
                </v-container>
            </v-card>
        </v-dialog>
        <v-dialog v-model="imageExtFlag" persistent max-width="400px">
            <v-card>
                <v-card-title class="headline"> File Format </v-card-title>
                <v-container>
                    <span>
                        <v-col cols="12" xs="12" sm="12" md="12">
                            <p class="slide">
                                File only in
                                <span v-for="type in imagetype" :key="type"> {{ type.imagetype }}</span>
                                Format!!!
                            </p>
                        </v-col>
                    </span>
                    <center>
                        <v-btn class="button" @click="imageExtFlag = false">OK</v-btn>
                    </center>
                </v-container>
            </v-card>
        </v-dialog>
        <v-form id="mtf_form" @submit.prevent="submit">
            <v-card class="box" v-for="(input, index) in inputs" in :key="index">
                <v-row>
                    <v-col cols="12" sm="1" md="1" align="left">
                        <v-text-field class="" label="Weightage" v-model.trim="input.marks" type="number" required
                            @change="calculatemarks()"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="1" md="1"></v-col>

                    <v-col cols="12" sm="1" md="1" v-if="index >= 2">
                        <v-btn color="red" fab small dark @click="deleteRow(index)" class="del">
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <p class="p-0 m-0">
                            <b>Question - {{ index + 1 }}</b>
                        </p>
                        <v-textarea label="Question" auto-grow v-model="input.sub_question" outlined
                            rows="3"></v-textarea>
                        <v-file-input accept="image/jpeg, image/jpg" v-model="input.sub_question_file"
                            hint="Option Image File size Should be less than 200kb And It Should be in JPEG Format"
                            prepend-icon="mdi-attachment" label="Choose File" show-size name="que"
                            @change="validateFileOptions(input.sub_question_file, index, 'addedque')"></v-file-input>
                    </v-col>
                    <v-col cols="12" sm="1" md="1" align="center">
                        <v-icon color="black" class="format-icon">mdi-arrow-left-right-bold</v-icon>
                    </v-col>
                    <v-col cols="12" sm="4" md="4">
                        <p class="p-0 m-0">
                            <b>Correct <span class="ml-2">Answer</span> </b>
                        </p>
                        <v-textarea label="Answer" auto-grow v-model="input.sub_answer" outlined rows="3"></v-textarea>
                        <v-file-input accept="image/jpeg, image/jpg" v-model="input.sub_answer_file"
                            hint="Option Image File size Should be less than 200kb And It Should be in JPEG Format"
                            prepend-icon="mdi-attachment" label="Choose File" show-size name="ans"
                            @change="validateFileOptions(input.sub_answer_file, index, 'addedans')"></v-file-input>
                    </v-col>
                </v-row>
            </v-card>
            <div v-show="optionsize <= 3">
                <v-btn class="button" @click="addRow"> Add Option </v-btn>
            </div>
        </v-form>
        <v-row justify="center" v-if="this.from != 'QB'">
            <v-btn class="button" @click="showStudents()">Select Students</v-btn>
        </v-row>
        <v-row justify="center" v-if="this.from == 'QB'">
            <v-btn class="button" @click="save()" :loading="loader">Save</v-btn>
        </v-row>
        <div class="text-center">
            <v-dialog v-model="dialog_upload" hide-overlay persistent width="300">
                <v-card color="primary" dark>
                    <v-card-text>
                        Please Wait
                        <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </div>
        <v-dialog v-model="dialogSize" persistent max-width="400px">
            <v-card>
                <v-card-title class="headline"> File Size </v-card-title>
                <v-container>
                    <span>
                        <v-col cols="12" xs="12" sm="12">
                            <p class="slide">File size should be less than {{ imagesize_new }} KB!</p>
                        </v-col>
                    </span>
                    <center>
                        <v-btn class="button" text @click="dialogSize = false">OK</v-btn>
                    </center>
                </v-container>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialogExt" persistent max-width="400px">
            <v-card>
                <v-card-title class="headline"> File Format </v-card-title>
                <v-container>
                    <span>
                        <v-col cols="12" xs="12" sm="12" md="12">
                            <p class="slide">
                                File only in
                                <span v-for="type in imagetype" :key="type">{{ type.imagetype }} </span>
                                Format!!!
                            </p>
                        </v-col>
                    </span>
                    <center>
                        <v-btn class="button" text @click="dialogExt = false">OK</v-btn>
                    </center>
                </v-container>
            </v-card>
        </v-dialog>

        <v-row justify="center">
            <v-dialog v-model="show_studnts" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar class="toolbar">
                        <v-btn icon dark @click="show_studnts = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>All Students</v-toolbar-title>
                        <v-toolbar-items>
                            <v-btn dark text @click="show_studnts = false">Close</v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-card class="box">
                        <v-row class="sub-row" justify="center" dense>
                            <v-col cols="12" xs="12" sm="12" lg="12" md="12">
                                <v-data-table :headers="headers_students" :items="learners" :search="search"
                                    class="elevation-1" show-select v-model="selected" item-key="lid"
                                    :items-per-page="-1"></v-data-table>
                            </v-col>
                        </v-row>
                    </v-card>
                    <v-row justify="center" v-if="this.from != 'QB'">
                        <v-btn class="button" @click="save()" :loading="loader">Save & Publish</v-btn>
                    </v-row>
                    <v-row justify="center" dense v-if="this.selected.length > 0">
                        <strong>Total Selected - {{ selected.length }}</strong>
                    </v-row>
                    <!-- <v-row justify="center" v-if="this.from=='QB'">
                            <v-btn class="button" @click="save()">Save</v-btn>
                         </v-row> -->
                </v-card>
            </v-dialog>
        </v-row>
        <!-- show editor -->
        <!-- <v-row justify="center">
            <v-dialog v-model="show_editor" fullscreen hide-overlay transition="dialog-bottom-transition">
                <v-card>
                    <v-toolbar class="toolbar">
                        <v-btn icon dark @click="show_editor = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <v-toolbar-title>Text Editor</v-toolbar-title>
                    </v-toolbar>
                    <br />
                    <v-row dense justify="center">
                        <v-col cols="12" sm="7" md="7">
                            <ckeditor v-model="textEditor" :config="editorConfig"></ckeditor>
                        </v-col>
                        <v-col cols="12" sm="3" md="3" v-if="textEditor">
                            <span><v-icon class="icon-quick" title="Copy text" @click="copy(textEditor)">mdi-content-copy</v-icon></span>
                        </v-col>
                    </v-row>
                </v-card>
            </v-dialog>
        </v-row> -->
    </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard

export default {
    props: {
        chapter: Number,
        sel_crs: Array,
        quiztype: String,
        from: String,
        Level: Number,
    },
    data() {
        return {
            total_weightage: 0,
            overlay: false,
            loader: false,
            headers_students: [
                { text: "Sr. No.", value: "count", sortable: "true" },
                { text: "Student", value: "name" },
            ],
            learners: [],
            show_studnts: false,
            search: null,
            total_students: [],
            selected: [],
            editorConfig: {
                height: "100px",
                extraPlugins: "mathjax",
                mathJaxLib: "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.1/MathJax.js?config=TeX-AMS_HTML",
            },
            snackbar_msg: "",
            color: "",
            snackbar: false,
            overlay: false,
            imagesize_new: null,
            imagetype_new: null,
            question_size: null,
            weightage: 1,
            qfile: null,
            question: null,
            optionsize: 0,
            // sub_question_01: null,
            // sub_question_01_file: null,
            // sub_answer_01: null,
            // sub_answer_01_file: null,
            // sub_answer_01_marks: 1,
            // sub_question_02: null,
            // sub_question_02_file: null,
            // sub_answer_02: null,
            // sub_answer_02_file: null,
            // sub_answer_02_marks: 1,

            inputs: [],
            dialogExt: false,
            imageSizeFlag: false,
            imageExtFlag: false,
            kb: null,
            dialogSize: false,
            dialogExt: false,
            filesize: null,
            imgtype: null,
            imagetype: [],
            dialog_upload: false,
            show_editor: false,
            textEditor: "",
        };
    },
    methods: {
        validateFile() {
            let file = this.qfile;
            let file_size = file.size;
            let file_name = this.qfile.name;
            let ext = file_name.split(".").pop();
            const data = {
                type: this.quiztype,
            };
            axios
                .post("/QuizQuestionBank/validatefile", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.imagesize = res.data.imagesize;
                        if (file_size > this.imagesize) {
                            this.imageSizeFlag = true;
                            this.dialogSize = true;
                            this.qfile = null;
                        } else {
                            this.imageSizeFlag = false;
                        }
                        this.imagetype = res.data.imagetype;
                        for (var i = 0; i < this.imagetype.length; i++) {
                            if (ext == this.imagetype[i].imagetype) {
                                this.imageExtFlag = false;
                                return;
                            }
                        }
                        for (var i = 0; i < this.imagetype.length; i++) {
                            if (ext != this.imagetype[i].imagetype) {
                                this.imageExtFlag = true;
                                this.dialogExt = true;
                                this.qfile = null;
                                return;
                            }
                        }
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    }
                })
                .catch((error) => {
                    this.onerror(error);
                    window.console.log(error);

                    this.showSnackbar("#b71c1c", "Something went wrong !!!");
                });
        },
        validateFileOptions(filename, index, demo) {
            let file1 = filename;
            let invalid = "";
            let file_size1 = file1.size;
            let file_name1 = filename.name;
            let ext1 = file_name1.split(".").pop();
            const data = {
                type: this.quiztype,
            };
            axios
                .post("/QuizQuestionBank/validatefile", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        console.log(res.data.imagesize);
                        this.imagesize = res.data.imagesize;
                        if (file_size1 > this.imagesize) {
                            this.dialogSize = true;
                            if (demo == "addedque") {
                                this.inputs[index].sub_question_file = null;
                            }
                            if (demo == "addedans") {
                                this.inputs[index].sub_answer_file = null;
                            }
                        } else {
                            this.dialogSize = false;
                        }
                        console.log(res.data.imagetype);
                        this.imagetype = res.data.imagetype;

                        for (var i = 0; i < this.imagetype.length; i++) {
                            if (ext1 == this.imagetype[i].imagetype) {
                                this.dialogExt = false;
                                return;
                            } else {
                                //alert("in else")
                                this.dialogExt = true;
                                invalid = "invalidfile";
                            }
                        }
                        if (invalid == "invalidfile") {
                            if (demo == "addedque") {
                                this.inputs[index].sub_question_file = null;
                            }
                            if (demo == "addedans") {
                                this.inputs[index].sub_answer_file = null;
                            }
                        }
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    }
                })
                .catch((error) => {
                    this.onerror(error);
                    window.console.log(error);

                    this.showSnackbar("#b71c1c", "Something went wrong !!!");
                });
        },
        //  validateFileAdd(filename, index, demo) {
        //   let file1 = filename;
        //   let invalid = "";
        //   let file_size1 = file1.size;
        //   let file_name1 = filename.name;
        //   let ext1 = file_name1.split(".").pop();
        //   let formData = new FormData();
        //   // alert(file_size1)
        //   axios
        //     .post("/MatchThePairAssignment/validatefile")
        //     .then((res) => {
        //       if (res.data.flag == "YES") {
        //         console.log(res.data.imagesize);
        //         this.imagesize = res.data.imagesize;
        //         if (file_size1 > this.imagesize) {
        //           this.dialogSize = true;
        //           if (demo == "addedque") {
        //             this.inputs[index].sub_question_file = null;
        //           }
        //           if (demo == "addedans") {
        //             this.inputs[index].sub_answer_file = null;
        //           }
        //         } else {
        //           this.dialogSize = false;
        //         }
        //         console.log(res.data.imagetype);
        //         this.imagetype = res.data.imagetype;

        //         for (var i = 0; i < this.imagetype.length; i++) {
        //           if (ext1 == this.imagetype[i].imagetype) {
        //             this.dialogExt = false;
        //             return;
        //           } else {
        //             //alert("in else")
        //             this.dialogExt = true;
        //             invalid = "invalidfile";
        //           }
        //         }
        //         if (invalid == "invalidfile") {
        //           if (demo == "addedque") {
        //             this.inputs[index].sub_question_file = null;
        //           }
        //           if (demo == "addedans") {
        //             this.inputs[index].sub_answer_file = null;
        //           }
        //         }
        //       } else {
        //         this.showsnackbar("Something went wrong...", "error", 1000);
        //       }
        //     })
        //     .catch((error) => {
        //       this.onerror(error);
        //       window.console.log(error);
        //     });
        // },

        calculatemarks() {
            this.total_weightage = 0;
            for (let i = 0; i < this.inputs.length; i++) {
                this.total_weightage += parseFloat(this.inputs[i].marks);
            }
        },
        showEditor() {
            // this.show_editor = true;
            let routeData = this.$router.resolve({
                name: "editor",
            });
            window.open(routeData.href, "_blank");
        },
        copy(text) {
            navigator.clipboard.writeText(text);
            //   alert("Text copied to clipboard!!!");
            this.showSnackbar("#4caf50", "Text copied to clipboard!!!");
        },
        showStudents() {
            this.show_studnts = true;
            this.markAllSelected();
        },
        markAllSelected() {
            this.selected = [];
            for (let i = 0; i < this.learners.length; i++) {
                this.selected.push(this.learners[i]);
            }
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
        onerror(error) {
            let msg = "";
            if (error.response) {
                msg = "Something went wrong.";
            } else if (error.request) {
                msg = "Please try again.";
            } else {
                msg = "Un-expected error.";
            }
            this.showSnackbar("error", msg);
        },
        getQuestionBank() {
            //console.log("getquestionbank12", this.sel_crs[0].coff_id);
            let crs_id = "";
            if (this.from == "QB") {
                crs_id = this.sel_crs;
            } else {
                crs_id = this.sel_crs[0].coff_id;
            }
            const data = {
                crs_id: crs_id,
                ch_id: this.chapter,
                type: this.quiztype,
                Level_id: this.Level,
            };
            axios
                .post("/QuizQuestionBank/getQuestionBank", data)
                .then((res) => {
                    this.question_size = res.data.question_size;
                    this.imagesize_new = res.data.imagesize / 1000;
                    this.imagetype_new = res.data.imagetype;
                })
                .catch((error) => {
                    window.console.log(error);

                    this.showSnackbar("#b71c1c", "Something went wrong !!!");
                })
                .finally(() => { });
        },
        addRow() {
            this.inputs.push({
                sub_question: null,
                sub_question_file: null,
                sub_answer: null,
                sub_answer_file: null,
                marks: 1,
            });
            this.optionsize++;
            this.calculatemarks();
        },
        deleteRow(index) {
            this.inputs.splice(index, 1);
            this.optionsize--;
            this.calculatemarks();
        },
        validatedata() {
            axios
                .post("/QuizQuestionBank/validatefile")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.filesize = res.data.imagesize / 1000 + "KB";
                        this.imgtype = res.data.imagetype;
                    } else {
                        this.showsnackbar("Something went wrong...", "error", 1000);
                    }
                })
                .catch((error) => {
                    this.onerror(error);
                    window.console.log(error);
                });
        },

        save() {
            var el_down = document.getElementById("GFG_DOWN");
            var form = document.getElementById("mtf_form");
            let formData = new FormData(form);
            //alert(this.qfile)
            if (this.qfile == null && this.question == null) {
                this.showSnackbar("#b71c1c", "Either option text or option image file is compulsary please add..."); // show snackbar
            } else {
                if (this.inputs.length != 0) {
                    this.total_weightage = 0;
                    //alert("In For LOOP")
                    for (let i = 0; i < this.inputs.length; i++) {
                        let id = this.add_pair + i;
                        this.total_weightage += parseFloat(this.inputs[i].marks);
                        formData.append("sub_id", i);
                        formData.append("sub_question", this.inputs[i].sub_question);
                        // if (this.inputs[i].sub_question_file != null) {
                        //   formData.append(
                        //     "sub_question_file",
                        //     this.inputs[i].sub_question_file
                        //   );
                        // } else {
                        //   formData.append("sub_question_file", null);
                        // }
                        formData.append("sub_answer", this.inputs[i].sub_answer);
                        // if (this.inputs[i].sub_answer_file != null) {
                        //   formData.append(
                        //     "sub_answer_file",
                        //     this.inputs[i].sub_answer_file
                        //   );
                        // } else {
                        //   formData.append("sub_answer_file", null);
                        // }
                        formData.append("marks", this.inputs[i].marks);
                        if (this.inputs[i].sub_question == "" && this.inputs[i].sub_question_file == "") {
                            this.showSnackbar("#b71c1c", "Either option text or option image file is compulsary please add..."); // show snackbar
                            return;
                        }
                        if (this.inputs[i].sub_answer == "" && this.inputs[i].sub_answer_file == "") {
                            this.showSnackbar("#b71c1c", "Either option text or option image file is compulsary please add..."); // show snackbar
                            return;
                        }
                    }
                } else {
                    //alert("out For LOOP")
                    formData.append("sub_id", "No_data");
                }
                // formData.append("sub_question_01", this.sub_question_01);
                // formData.append("sub_question_01_file", this.sub_question_01_file);
                // formData.append("sub_answer_01", this.sub_answer_01);
                // formData.append("sub_answer_01_file", this.sub_answer_01_file);
                // formData.append("sub_answer_01_marks", this.sub_answer_01_marks);
                // formData.append("sub_question_02", this.sub_question_02);
                // formData.append("sub_question_02_file", this.sub_question_02_file);
                // formData.append("sub_answer_02", this.sub_answer_02);
                // formData.append("sub_answer_02_file", this.sub_answer_02_file);
                // formData.append("sub_answer_02_marks", this.sub_answer_02_marks);
                formData.append("type", "MTP");
                formData.append("total_weightage", this.total_weightage);
                formData.append("question", this.question);
                formData.append("qfile", this.qfile);
                if (this.from == "QB") {
                    formData.append("crs_id", this.sel_crs);
                } else {
                    formData.append("crs_id", this.sel_crs[0].coff_id);
                    for (var i = 0; i < this.selected.length; i++) {
                        this.total_students.push(this.selected[i].lid);
                        formData.append("total_students", this.selected[i].lid);
                    }
                    if (this.total_students.length <= 0) {
                        this.showSnackbar("#b71c1c", "Please select Students!"); // show snackbar
                    }
                }
                formData.append("ch_id", this.chapter);
                formData.append("Level_id", this.Level);
                formData.append("from", this.from);
                for (let i = 0; i < this.sel_crs.length; i++) {
                    formData.append("coi_id", this.sel_crs[i].coi_id);
                }

                this.dialog_upload = true;
                this.overlay = true;
                this.loader = true;
                axios
                    .post("/LiveClass/saveQuestionInBankMTP", formData, {})
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Saved And Published Successfully...");
                            this.dialog_upload = false;
                            this.loader = false;
                            this.reset();
                            (this.total_students = []), (this.show_studnts = false);
                            this.addFirstTwoRows();
                            // $(window).scrollTop($("#GFG_DOWN").position().top);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("red", "Something went wrong...");
                        this.dialog_upload = false;
                    })
                    .finally(() => {
                        this.overlay = false;
                        this.loader = false;
                    });
            }
        },
        reset() {
            (this.question = null),
                (this.qfile = null),
                //(this.iscorrect_01 = null),
                // (this.optfile1 = null),
                // (this.optfile2 = null),
                // (this.option_01 = null),
                // (this.option_02 = null);
                (this.inputs = []);
            // (this.sub_question_01 = null),
            // (this.sub_question_01_file = null),
            // (this.sub_answer_01 = null),
            // (this.sub_answer_01_file = null),
            // (this.sub_answer_01_marks = 1),
            // (this.sub_question_02 = null),
            // (this.sub_question_02_file = null),
            // (this.sub_answer_02 = null),
            // (this.sub_answer_02_file = null),
            // (this.sub_answer_02_marks = 1);
        },
        addFirstTwoRows() {
            this.inputs.push({
                sub_question: null,
                sub_question_file: null,
                sub_answer: null,
                sub_answer_file: null,
                marks: 1,
            });
            this.optionsize++;

            this.inputs.push({
                sub_question: null,
                sub_question_file: null,
                sub_answer: null,
                sub_answer_file: null,
                marks: 1,
            });
            this.optionsize++;
        },
    },
    mounted() {
        //  alert(this.chapter)
        //  alert(this.sel_crs)
        //alert(this.from)
        // console.log("sel_crs LiveMCQ", this.sel_crs);
        this.getQuestionBank();
        this.addFirstTwoRows();
        this.learners = JSON.parse(localStorage.getItem("live-session-students"));
        this.calculatemarks();
    },
};
</script>
<style scoped>
.slide {
    color: red;
    font-weight: bold;
    margin-left: 10px;
}

.format-icon {
    margin-top: 67%;
    font-size: 40px;
    text-align: center;
}
</style>
